module.exports = __webpack_public_path__ + "static/logo-full-75ca51490c830784306f318e3bf52cd7.png";